export default [
  {
    path: 'follow-up-actions',
    name: 'follow-up-action-settings',
    meta: {
      requiredPrivileges: ['System Settings']
    },
    component: () =>
      import(
        '@/modules/global-settings/follow-up-actions/views/FollowUpActionSettings.vue'
      )
  }
];
